import type { RouteRecordRaw } from 'vue-router';
import { ShowMyClassMenuEnum } from '../../type/auth';
import type { MenuItem } from '../../type/menu';

const useClassMenuPermission = (
  menuList: Array<MenuItem>,
  routerList: Array<RouteRecordRaw>,
  status: ShowMyClassMenuEnum
): [Array<MenuItem>, Array<RouteRecordRaw>] => {
  let nextMenuList = Array.from(menuList);
  const nextRouterList = Array.from(routerList);
  // https://yach-doc-shimo.zhiyinlou.com/docs/gXqmeQ62aMirWpqo/ <框架优化三期_新旧替换技术方案>
  if (status === ShowMyClassMenuEnum.HIDE) {
    // 隐藏我的班级模块
    const filterHelper = (route: MenuItem | RouteRecordRaw) => route.name !== 'myClass';
    nextMenuList = menuList.filter(filterHelper);
    routerList = routerList.map((router) => {
      if (router.name === 'home') {
        router.children = router.children?.map((route) => {
          if (route.name === 'myClass') {
            route.redirect = '/newMyClass';
          }
          return route;
        });
      }
      return router;
    });
  } else {
    // do nothing
  }
  return [nextMenuList, nextRouterList];
};

export default useClassMenuPermission;
